module.exports = new __parcel__URL__("golemhuddle.7f397fb8.png").toString();